module.exports = __webpack_public_path__ + "static/media/dont4.fccbcdae.png";